<div fxLayout="column" class="page-wrapper autoScrollY">
    <mat-form-field style="margin-left: 20px; width: 200px;">
        <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter()" name="SearchDualList" class="form-control" [(ngModel)]="filter"
            autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="clearSelection()">
            <mat-icon>close</mat-icon>
        </a>
    </mat-form-field>
    <div class="shared-scene-table">
        <table mat-table class="mat-elevation-z8" [dataSource]="dataSource">
            <ng-container matColumnDef="businessId">
                <th mat-header-cell *matHeaderCellDef>{{ 'general.business' | transloco }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.businessId }}</td>
            </ng-container>
            <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef><span>{{ 'general.specialized' | transloco }}</span></th>
                <td mat-cell *matCellDef="let element">
                    <fa-icon size="lg" style="opacity: 0.7;" [icon]="element.sceneData.Player.$.mimeType | PipeIcon"></fa-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="label">
                <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef>{{ 'general.name' | transloco }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.sceneData.Player.$.label }}</td>
            </ng-container>
            <ng-container matColumnDef="items">
                <th mat-header-cell *matHeaderCellDef>{{ 'general.items' | transloco }}</th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.sceneData.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player?.length }}
                </td>
            </ng-container>
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>{{ 'general.id2' | transloco }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.sceneData.Player.$.id }}</td>
            </ng-container>
            <ng-container matColumnDef="modified">
                <th mat-header-cell *matHeaderCellDef>{{ 'general.modified' | transloco }}</th>
                <td mat-cell *matCellDef="let element"> {{ element.sceneData.Player.$?.lastModified | StringJSV2Pipe:stringJSPipeArgs }}</td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ 'general.specialized' | transloco }}</th>
                <td mat-cell *matCellDef="let element">
                    @if (element.sceneData.Player.$.mimeType?.length === 0 || element.sceneData.Player.$.mimeType === 'mainPlayer') {
                        <div>Player</div>
                    } @else {
                        {{ element.sceneData.Player.$.mimeType | StringJSV2Pipe:stringJSPipeJson | StringJSV2Pipe:stringJSPipeJson2 }}
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="preview">
                <th mat-header-cell *matHeaderCellDef>Download</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button class="mini-button" (click)="importSharedScene(element)" matTooltip="{{'general.importScene' | transloco}}">
                        <mat-icon>download</mat-icon>
                    </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="play">
                <th mat-header-cell *matHeaderCellDef>Play</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button class="mini-button" (click)="previewSharedScene(element)" matTooltip="Preview Scene">
                        <mat-icon>play_arrow</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row class="table-row" tabindex="1" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        @if (!dataSource) {
            <div style="overflow: hidden; height: 250px">
                <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
                <br/>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon>hourglass_empty</mat-icon>
                    {{ 'placeholder.makeTakeMinute' | transloco }} ...
                </div>
            </div>
        }
    </div>
    <mat-paginator #paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true">
    </mat-paginator>
</div>

<ng-template #sharedSceneModal>
    <div mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="header">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </div>
    <div mat-dialog-content>
        <div class="shared-scene">
            @if (sharedSceneId) {
                <app-scene-preview
                        [setSelectedSceneId]="sharedSceneId"
                        [setSceneWidth]="sharedSceneWidth"
                        [setSceneHeight]="sharedSceneHeight"
                        [previewWidth]="600"
                        [autoScale]="true"
                        (sceneLoaded)="onSceneLoaded($event)">
                </app-scene-preview>
                @if (loadingScenePreview) {
                    <ngx-skeleton-loader
                            animation="progress-dark"
                            class="preview-loader"
                            [theme]="{
                                'height': '100%',
                                'border-radius': '0',
                                'background-color': 'var(--background-color5)'
                            }">
                    </ngx-skeleton-loader>
                }
            } @else {
                <div>Sorry, failed to import shared scene</div>
            }
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="32px" style="margin-top: 30px;">
            @if (sharedSceneId) {
                <button mat-raised-button color="warn" (click)="jumpToSceneItem()">
                    <mat-icon>login</mat-icon>
                    {{ 'general.jumpToScene' | transloco }}
                </button>
            }
            <button mat-raised-button color="primary" (click)="closeModal()"
                    style="min-width: 120px;">
                {{ 'general.cancel' | transloco }}
            </button>
        </div>
    </div>
</ng-template>


<!-- @if (sharedScenes.length > 0) {
    <div fxFlex fxLayout="row wrap" style="margin: 10px;">
    
        @for (item of sharedScenes; track item) {
            <div class="shared-scene">
                <div class="preview">
                    <img src="./assets/images/empty_scene.png" style="height: 100%;"/>
                </div>
                <div class="title">shared scene</div>
                <div class="overlay">
                    <a style="background-color: #0d66c2" mat-icon-button class="mini-button jump-icon" (click)="jumpToSceneItem(item.sceneId)" matTooltip="{{'general.jumpToScene' | transloco}}">
                        <mat-icon style="color: white">download</mat-icon>
                    </a>
                </div>
            </div>
        }
    </div>
} @else {
    <div class="d-flex-center">
        no shared scenes
    </div>
} -->